import { useRef, useState } from "react";
import { Upload, Loader2, Film } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const CHUNK = 4 * 1024 * 1024;

export const VideoUploader = ({ onUploaded }) => {
  const input = useRef(null);
  const [progress, setProgress] = useState(null);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 200 * 1024 * 1024) { toast.error("Μέγιστο μέγεθος 200MB"); return; }
    const uploadId = crypto.randomUUID();
    const total = Math.ceil(file.size / CHUNK);
    setProgress(0);
    try {
      for (let i = 0; i < total; i++) {
        const fd = new FormData();
        fd.append("upload_id", uploadId);
        fd.append("index", String(i));
        fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), `${i}.part`);
        await api.post("/admin/videos/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setProgress(Math.round(((i + 1) / total) * 95));
      }
      const { data } = await api.post("/admin/videos/complete", { upload_id: uploadId, filename: file.name, total });
      setProgress(100);
      toast.success("Το βίντεο ανέβηκε στο cloud");
      onUploaded(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setTimeout(() => setProgress(null), 800);
      if (input.current) input.current.value = "";
    }
  };

  return (
    <div className="rounded-[20px] border border-dashed border-[#93C5FD] bg-[#F8FAFF] p-5" data-testid="video-uploader">
      <div className="flex flex-wrap items-center gap-4">
        <span className="w-10 h-10 rounded-2xl bg-[#1D4ED8] flex items-center justify-center"><Film className="w-5 h-5 text-white" /></span>
        <div className="flex-1 min-w-[200px]">
          <p className="text-sm font-bold text-[#0B1B3A]">Ανέβασε βίντεο (mp4/webm, έως 200MB)</p>
          <p className="text-xs text-[#64748B]">Ανεβαίνει τμηματικά στο ασφαλές cloud και προστίθεται ως διαφάνεια «video».</p>
        </div>
        <input ref={input} data-testid="video-file-input" type="file" accept="video/mp4,video/webm" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
        <button type="button" data-testid="video-upload-button" disabled={progress !== null} onClick={() => input.current?.click()} className="btn-blue !px-5 !py-2 text-sm disabled:opacity-60">
          {progress !== null ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {progress !== null ? `${progress}%` : "Επιλογή αρχείου"}
        </button>
      </div>
      {progress !== null && (
        <div className="h-2 bg-white rounded-full mt-4 overflow-hidden" data-testid="video-upload-progress">
          <div className="h-full bg-[#1D4ED8] transition-all duration-300" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );
};

export default VideoUploader;
